import React, { useEffect, useState } from 'react';
import { useDataEngine } from '@dhis2/app-runtime';
import { useAuth } from '../../auth/AuthContext';

const ObjectiveSharingSetup = () => {
    const engine = useDataEngine();
    const { user } = useAuth();
    const [message, setMessage] = useState('');

    
    const userGroups = {
        CEO: 'HX3KpMqekvQ',
        HOD: 'DxVo5hprMUT',
        TopStaff: 'DvljV6tAg4V',
        SeniorStaff: 'NlVOvQKmhqr',
    };

    // Fetch users by role
    const fetchUsersByRole = async (roleId) => {
    try {
        const query = {
            users: {
                resource: 'users',
                params: {
                    fields: 'id,displayName',
                    filter: `userCredentials.userRoles.id:eq:${roleId}`,
                    paging: false
                }
                }
            };
            const result = await engine.query(query);
            return result?.users?.users || []; // Note the nested structure
        } catch (error) {
            console.error('Error fetching users by role:', error);
            return [];
        }
    };

    // Update sharing for a single org unit
const updateSharingForOrgUnit = async (orgUnitId) => {
    if (!orgUnitId) return;

    try {
        console.log(`Updating sharing for org unit: ${orgUnitId}`);

        // 1. Fetch FULL org unit (required fields + sharing)
        const response = await engine.query({
            organisationUnit: {
                resource: `organisationUnits/${orgUnitId}`,
                params: {
                    fields: 'id,name,shortName,code,openingDate,closedDate,parent[id],publicAccess,userGroupAccesses[id,access],userAccesses[id,access]'
                }
            }
        });

        const orgUnit = response.organisationUnit;
        if (!orgUnit) {
            console.warn('Org unit not found:', orgUnitId);
            return;
        }

        // 2. Build payload: keep all required metadata, update only sharing
        const sharingPayload = {
            id: orgUnit.id,
            name: orgUnit.name,
            shortName: orgUnit.shortName || orgUnit.name.substring(0, 50),
            openingDate: orgUnit.openingDate || new Date().toISOString().split('T')[0],
            parent: orgUnit.parent ? { id: orgUnit.parent.id } : undefined,
            // Sharing fields
            publicAccess: 'r-------',
            userGroupAccesses: [
                { id: userGroups.HOD, access: 'r-------' },
                { id: userGroups.TopStaff, access: 'r-------' },
                { id: userGroups.SeniorStaff, access: 'r-------' }
            ],
           
        };

        // Remove undefined fields (e.g., if no parent)
        Object.keys(sharingPayload).forEach(key => {
            if (sharingPayload[key] === undefined) delete sharingPayload[key];
        });

        console.log('Sending sharing update payload:', sharingPayload);

        // 3. Update via metadata endpoint
        await engine.mutate({
            resource: `organisationUnits/${orgUnitId}`,
            type: 'update',
            data: sharingPayload
        });

        console.log(`✅ Sharing updated for org unit: ${orgUnitId}`);
    } catch (error) {
        console.error(`❌ Failed to update sharing for ${orgUnitId}:`, error.message || error);
    }
};

    // Loop through all org units of the current user
    useEffect(() => {
        if (!user?.organisationUnits) return;

        const updateAllOrgUnits = async () => {
            setMessage('Updating system for all assigned org units...');
            for (const ou of user.organisationUnits) {
                await updateSharingForOrgUnit(ou.id);
            }
            setMessage('All system updates completed.');
        };

        updateAllOrgUnits();
    }, [user]);

    return (
    <div
        style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: message === 'All system updates completed.' ? '#e8f5e9' : '#fff8e1',
        border: `1px solid ${message === 'All system updates completed.' ? '#c8e6c9' : '#ffe082'}`,
        borderRadius: 20,
        color: message === 'All system updates completed.' ? '#2e7d32' : '#f57c00',
        fontSize: '13px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        }}
    >
        {message === 'All system updates completed.' ? '✅' : '⏳'} {message}
    </div>
    );
};

export default ObjectiveSharingSetup;
